module.exports = __webpack_public_path__ + "static/media/300.f9f27908.jpg";